import React from 'react'
import { NavLink } from 'react-router-dom'

const AssignmentsSubNav = () =>
  <ul className='usa-sidenav-sub_list assignments-sub-nav'>
    <li>
      <NavLink
        activeClassName='usa-current'
        to='/lgyhub/appraiser/locate-cases/canceled-90-days'>
        Canceled in the Past 90 Days
      </NavLink>
    </li>
    <li>
      <NavLink
        activeClassName='usa-current'
        to='/lgyhub/appraiser/locate-cases/all-90-days'>
        All in the Past 90 Days
      </NavLink>
    </li>
    <li>
      <NavLink
        activeClassName='usa-current'
        to='/lgyhub/appraiser/locate-cases/with-uploads'>
        Appraisal Uploaded in the Past 30 Days
      </NavLink>
    </li>
  </ul>

export default AssignmentsSubNav
